import { render, staticRenderFns } from "./ConferenceCenter.vue?vue&type=template&id=6585e8d3&scoped=true&"
import script from "./ConferenceCenter.vue?vue&type=script&lang=js&"
export * from "./ConferenceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585e8d3",
  null
  
)

export default component.exports